import { z } from 'zod'

export const fetchErpStatusResponseSchema = z.object({
  connected: z.boolean(),
  erp_accounting_app: z.string().or(z.null()),
  has_valid_mapping: z.boolean(),
  latest_sync_timestamp: z.string().or(z.null()),
  connected_timestamp: z.array(z.string()).or(z.null()),
  company_info: z
    .array(
      z.object({
        _id: z.string(),
        name: z.string(),
      })
    )
    .or(z.string()),
})

// The `filter_options` endpoint can return the `syncstatus` field with non-string
// entries mixed in (e.g. a stray `null` alongside "Unsynced"/"Errored"). A plain
// `z.array(z.string())` would throw on those during render and crash the whole
// Transactions page. `.catch([])` guards against a non-array value, and the transform
// drops any non-string entries while preserving the valid sync-status options.
export const syncStatusFilterSchema = z
  .array(z.unknown())
  .catch([])
  .transform((items) => items.filter((item): item is string => typeof item === 'string'))
